import React from "react";
import AvatarViewer from "../iconPicker/avatarViewer";
import AppIcons from "../../assets/images/icons";
import S3ImageViewerWithFallback from "../awsS3ImageViewer/ImgViewerWithFallback";
import './index.scss';


const LogoPreview = ({ uploadedLogo, formData }) => {
  const logoValue = uploadedLogo?.preview || formData?.chatLogoImg || '';
  const isFullUrl = logoValue.startsWith('http');

  return (

      <div
        className={`logo-preview-icon ${
          formData?.isAddRotatingAvatarAndLogo ? "rotating-logo" : ""
        }`}
      >
        <div className="rotating-card">
          {/* Front Side */}
          <div className="card-face card-front">
            {logoValue ? (
              <S3ImageViewerWithFallback
                fileURL={isFullUrl ? logoValue : ''}
                fileKey={!isFullUrl ? logoValue : ''}
              />
            ) : (
              <img src={AppIcons.defaultLogoImg} alt="logo preview" />
            )}
          </div>

          {/* Back Side */}
          {formData?.isAddRotatingAvatarAndLogo && (
            <div className="card-face card-back">
              {formData?.avatarImg && (
                <AvatarViewer
                  className="chat-head"
                  avatar={formData.avatarImg}
                />
              )}
            </div>
          )}
        </div>
      </div>

  );
};

export default LogoPreview;